<template>
    <UApp :toaster="toaster">
        <div class="sticky top-0 z-999">
            <MainNavigationNew @open-contact-person="openModalContactPerson = true"/>
        </div>
        <HeaderNew/>
        <UMain>
            <NuxtPage/>
            <Footer/>
            <SearchContactPersonNew
                :show-modal-contact-person="openModalContactPerson"
                :zip="zip"
                class="z-9999"
                @update:show-modal-contact-person="openModalContactPerson = $event"
            />
        </UMain>
    </UApp>
</template>

<script setup lang="ts">
import MainNavigationNew from '~/components/Header/MainNavigationNew.vue';
import type {ToasterProps} from '#ui/components/Toaster.vue';

const route = useRoute();
const toaster = <ToasterProps>{position: 'top-right'};
const openModalContactPerson = ref(false);
const zip = ref('');

if (route.name === 'contactPerson') {
    if (route.params.zip !== undefined && route.params.zip !== '') {
        openModalContactPerson.value = true;
        zip.value = route.params?.zip;
    } else {
        openModalContactPerson.value = true;
        zip.value = '';
    }
}
</script>
